<script lang="ts">
  import type { CustomerAddress } from '$lib/server/external/customerExternalData';

  const { address }: { address: CustomerAddress } = $props();
</script>

<div>
  {#if 'name' in address && address.name != null && (('is_company' in address && address.is_company) || !('is_company' in address))}
    <div>{address.name}</div>
  {/if}

  {#if 'att_name' in address && address.att_name != null}
    Att: {address.att_name}<br />
  {/if}

  {#if address.name == null && 'first_name' in address && address.first_name != null && 'surname' in address && address.surname != null}
    {address.first_name} {address.surname}<br />
  {/if}

  {#if address.address != null}
    {address.address}<br />
  {/if}

  {#if address.address2 != null}
    {address.address2}<br />
  {/if}

  {#if address.zip != null && address.city != null && address.country != null && address.country_code === 'us'}
    {address.city}, {address.county} {address.zip}<br />
  {:else if address.zip != null && address.city != null}
    {address.zip} {address.city}<br />
  {/if}

  {#if address.country != null}
    {address.country}
    {#if address.county != null && address.country_code !== 'us'}
      {address.county}
    {/if}
  {/if}
</div>
